import { isLessonComplete, getCompletedAt } from './helpers'
import markdownIt from 'markdown-it'
const md = markdownIt()

export default function ({ status, data }, courseId, user, api) {
  let html = null
  let markdown = null
  let complete = false
  let completedAt = null
  let meta
  if (data && data.content) {
    html = md.render(data.markdown)
    markdown = data.markdown
  } else {
    if (status === 200) {
      html = md.render(data.markdown)
      markdown = data.markdown
    }
  }
  if (status === 200) {
    complete = user ? isLessonComplete(courseId, data.id, user) : false
    completedAt = user ? getCompletedAt(courseId, data.id, user) : null
  }
  meta = {
    content: data.content,
    markdown: data.markdown,
  }
  delete meta.markdown
  return {
    status,
    lesson: {
      id: data.id,
      title: data.title,
      order: data.order,
      createdAt: data.createdAt,
      updatedAt: data.updatedAt,
      meta,
      markdown,
      html,
      complete,
      completedAt,
      async markComplete() {
        if (status === 200) {
          if (complete) {
            return true
          }
          return await api.setComplete(courseId, data.id, true, user)
        }
        return false
      },
      async markIncomplete() {
        if (status === 200) {
          if (!complete) {
            return true
          }
          return await api.setComplete(courseId, data.id, false, user)
        }
        return false
      }
    }
  }
}
